<div class="success-modal">
  <div class="success-modal-wrapper">
    <div class="success-modal-img">
      <img
        src="../../../../assets/img/pulse-success.svg"
        [alt]="lextranslate.i18n['bbb88471-c4b6-4d51-b075-7eaf3ac7a5d7']"
      />
    </div>
    <div class="success-modal-div-p">
      <p class="sucess-modal-p">
        {{ lextranslate.i18n["d650ac73-a914-4f26-b977-dd830aa0d036"] }}
      </p>
    </div>
    <div class="success-modal-div-button">
      <button
        mat-button
        class="reset-login-confirm-btn"
        [mat-dialog-close]="false"
      >
        <span class="reset-login-btn-span">{{
          lextranslate.i18n["b2a810a3-4965-4ef1-8afc-982b00432689"] | uppercase
        }}</span>
      </button>
    </div>
  </div>
  <button mat-icon-button [mat-dialog-close]="false" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>
